/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Note_PlaceholderInputs */

const en_us2_exercise_personal_note_placeholder = /** @type {(inputs: Exercise_Personal_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E.g. bench on hole 4, grip on the ring`)
};

const pt_br2_exercise_personal_note_placeholder = /** @type {(inputs: Exercise_Personal_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: banco no furo 4, pegada no anel`)
};

const es_419_exercise_personal_note_placeholder = /** @type {(inputs: Exercise_Personal_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ej.: banco en el agujero 4, agarre en el anillo`)
};

const pt_pt2_exercise_personal_note_placeholder = /** @type {(inputs: Exercise_Personal_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: banco no furo 4, pega no anel`)
};

const fr_fr2_exercise_personal_note_placeholder = /** @type {(inputs: Exercise_Personal_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex. : banc au cran 4, prise sur la bague`)
};

const de_de2_exercise_personal_note_placeholder = /** @type {(inputs: Exercise_Personal_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z. B. Bank auf Loch 4, Griff am Ring`)
};

const it_it2_exercise_personal_note_placeholder = /** @type {(inputs: Exercise_Personal_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es. panca al foro 4, presa all'anello`)
};

/**
* | output |
* | --- |
* | "E.g. bench on hole 4, grip on the ring" |
*
* @param {Exercise_Personal_Note_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_note_placeholder = /** @type {((inputs?: Exercise_Personal_Note_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Note_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_note_placeholder(inputs)
	if (locale === "es-419") return es_419_exercise_personal_note_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_note_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_note_placeholder(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_note_placeholder(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_note_placeholder(inputs)
	return en_us2_exercise_personal_note_placeholder(inputs)
});
export { exercise_personal_note_placeholder as "exercise-personal.note_placeholder" }